import { useEffect } from 'react';
import { useReveal } from '../components/useReveal';
import { SITE } from '../data/site';
import './ContentPage.css';

const CHANNELS = [
  {
    label: 'General',
    email: SITE.emails.info,
    note: 'Questions about the arcade, or anything that doesn’t fit a box below.',
    accent: 'var(--neon-cyan)',
  },
  {
    label: 'Support & billing',
    email: SITE.emails.support,
    note: 'Account help, Pass and payment questions, bug reports, and data requests.',
    accent: 'var(--neon-magenta)',
  },
  {
    label: 'Feedback',
    email: SITE.emails.feedback,
    note: 'Ideas, requests, and what you’d love to see in the cabinet next.',
    accent: 'var(--neon-lime)',
  },
  {
    label: 'Press & partnerships',
    email: SITE.emails.press,
    note: 'Media, reviews, collaborations, and partnership enquiries.',
    accent: 'var(--neon-violet)',
  },
] as const;

export function ContactPage() {
  useReveal('contact');
  useEffect(() => {
    document.title = `Contact — ${SITE.name}`;
  }, []);

  return (
    <article className="page">
      <div className="page__glow" aria-hidden="true" />
      <header className="page__head shell">
        <p className="eyebrow">Say hello</p>
        <h1 className="page__title">Drop us a line.</h1>
        <p className="page__lede">
          There&rsquo;s no support ticket maze here — just email. Pick the channel that fits and
          we&rsquo;ll get back to you.
        </p>
      </header>

      <div className="contact-grid shell">
        {CHANNELS.map((c) => (
          <a
            key={c.label}
            className="contact-card reveal"
            href={`mailto:${c.email}`}
            style={{ ['--card-accent' as string]: c.accent }}
          >
            <span className="contact-card__label">{c.label}</span>
            <span className="contact-card__email">{c.email}</span>
            <span className="contact-card__note">{c.note}</span>
            <span className="contact-card__arrow" aria-hidden="true">
              &#9656;
            </span>
          </a>
        ))}
      </div>

      <div className="page__cta shell">
        <a className="btn" href={SITE.appUrl}>
          PLAY THE ARCADE &#9656;
        </a>
      </div>
    </article>
  );
}
